/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Leadership_Advisor_RoleInputs */

const en_landing_leadership_advisor_role = /** @type {(inputs: Landing_Leadership_Advisor_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Advisor`)
};

/**
* | output |
* | --- |
* | "Advisor" |
*
* @param {Landing_Leadership_Advisor_RoleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const landing_leadership_advisor_role = /** @type {((inputs?: Landing_Leadership_Advisor_RoleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Leadership_Advisor_RoleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_landing_leadership_advisor_role(inputs)
});